import { render, staticRenderFns } from "./ClientCatalog.vue?vue&type=template&id=6798e258"
import script from "./ClientCatalog.vue?vue&type=script&lang=js"
export * from "./ClientCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports